// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__4nw+1","dark":"BaseLayout_dark__0p8dC","light":"BaseLayout_light__m87BJ"};